import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import type { ComponentPropsWithoutRef, ElementRef, ReactNode } from 'react';
import { forwardRef, useId } from 'react';
import { cn } from '../../utils/cn';
import { Checkbox } from './checkbox';

export type CheckboxLabeledProps = ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  label: ReactNode;
  containerClassName?: string;
  labelClassName?: string;
};

export const CheckboxLabeled = forwardRef<ElementRef<typeof CheckboxPrimitive.Root>, CheckboxLabeledProps>(
  ({ label, containerClassName, labelClassName, id, ...checkboxProps }, ref) => {
    const generatedId = useId();
    const checkboxId = id ?? generatedId;

    return (
      <label
        htmlFor={checkboxId as string | undefined}
        className={cn(
          'flex cursor-pointer items-center gap-3',
          {
            'cursor-not-allowed': checkboxProps.disabled,
          },
          containerClassName,
        )}
      >
        <Checkbox ref={ref} id={checkboxId} {...checkboxProps} />

        <span
          className={cn(
            'min-w-0 leading-snug break-words whitespace-normal',
            { 'text-muted-foreground': checkboxProps.disabled },
            labelClassName,
          )}
        >
          {label}
        </span>
      </label>
    );
  },
);
